import { Card } from '@/components/Bicester';
import Image from '@/components/Bicester/Image';
import { Role, ROLE_TYPE } from '@/constants';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { getPathname } from '@/utils/history';
import React from 'react';
import { IconButton } from 'rsuite5';

const UploadBasicInfo = ({ currentMember }: { currentMember: any }) => {
  const { profile } = useReadyInfo();

  return (
    <Card smDivider className="flex-1 flex flex-col">
      <Card.Input
        notEditable
        label="上传方"
        formKey="uploader"
        value={`${Role[profile?.role]}-${profile?.user_name}`}
      />
      {currentMember && (
        <>
          <div className="flex">
            <Card.Input
              notEditable
              className="flex-[3]"
              label="客户名"
              formKey="name"
              value={currentMember?.name}
              autoWidth
              hasBtn={profile?.role !== ROLE_TYPE.PT}
              customBtn={
                <IconButton
                  style={{ width: 20, backgroundColor: 'transparent' }}
                  onClick={() =>
                    window.open(getPathname(`/customer-account/member/detail/${currentMember?.id}`))
                  }
                >
                  <Image
                    src={`/resources/images/user${
                      currentMember?.sex === '男'
                        ? '-man'
                        : currentMember?.sex === '女'
                        ? '-woman'
                        : ''
                    }.svg`}
                  />
                </IconButton>
              }
              labelWeight={2}
              contentWeight={1}
            />
            <Card.Picker
              notEditable
              label="性别"
              formKey="sex"
              pickerType="sex"
              value={currentMember?.sex}
            />
          </div>
          <Card.Input
            notEditable
            label="会员等级"
            formKey="level"
            inputType="level"
            value={currentMember?.level}
          />
          <Card.Input
            notEditable
            label="今年消费"
            formKey="price_this_year"
            inputType="price"
            value={currentMember?.price_this_year}
          />
          <Card.Input
            notEditable
            label="累计消费"
            formKey="price"
            inputType="price"
            value={currentMember?.price}
          />
        </>
      )}
    </Card>
  );
};

export default UploadBasicInfo;
